import React from "react";
import {Grid} from "@material-ui/core";
import {withStyles} from "@material-ui/core/styles";
import TabPage from "./Tab";


const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },
    mainGrid: {
        marginTop: theme.spacing.unit * 3,
    },
    Paper: {
        padding: theme.spacing.unit * 3,
        margin: theme.spacing.unit * 3
    },
    typography: {
        useNextVariants: true,
    },
    section: {
        height: "100%",
        paddingTop: 5,
        backgroundColor: "#fff"
    }
});



const TechnicalService = (props) => {

    const {classes} = props;
    //const match = props.match.path;
    // console.debug("TechnicalService:props",props);
    return (

        
        <Grid container className={classes.root}  spacing={8}>
            <Grid item xs>
                <TabPage />
            </Grid>
            
        </Grid>

    );
};

export default withStyles(styles)(TechnicalService);